<template>
    <div>
        <vx-card class="mt-4 bg-gray-100 text-gray-700 border-t border-gray-300">
            <vs-row class="flex flex-wrap justify-between">

            <!-- Social Media Icons -->
            <vs-col v-if="false" vs-lg="4" vs-sm="12" vs-xs="12" class="text-center my-2">
                <div class="flex justify-center space-x-4 text-2xl text-blue-500">
                    <a href="https://www.facebook.com/ilerno">
                        <i class="material-icons-outlined cursor-pointer hover:text-blue-700">facebook</i>
                    </a>
                </div>
            </vs-col>

            <!-- Copyright -->
            <vs-col vs-lg="8" vs-sm="12" vs-xs="12" class="text-center my-2">
                <p class="text-gray-600 text-center lg:text-left">
                <strong>© {{ this.$moment().year() }} ilerno. All rights reserved. Scoolio Ltd.</strong>
                </p>
            </vs-col>

            <!-- Terms & Conditions -->
            <vs-col vs-lg="4" vs-sm="12" vs-xs="12" class="text-center lg:text-right my-2">
                <h5 @click="openTermsConditionPage()" class="terms-link">
                    Terms & Conditions
                </h5>
            </vs-col>

            </vs-row>
        </vx-card>
    </div>
</template>

<script>
export default {
    name: 'TermsAndConditions',
    data() {
        return {
            // Data properties can be added here if needed
        };
    },
    methods: {
        // Methods can be added here if needed
        openTermsConditionPage()
        {
            // move to terms & condition page
            this.$router.push({ name: 'terms-and-conditions' });
        },
    }
};
</script>
<style scoped>
.terms-link {
  color: #00577b;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.terms-link:hover {
  text-decoration: underline;
  color: #00577b;
}
</style>